import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api/courses`;

export const fetchCourses = async (params = {}) => (await axios.get(API, { params })).data.items;
export const fetchCourse = async (slug) => (await axios.get(`${API}/${encodeURIComponent(slug)}`)).data;
export const fetchCourseCategories = async () => (await axios.get(`${API}/meta/categories`)).data.categories;
